import React, { Component } from "react";
import { Redirect } from 'react-router';
import { Link, Route , withRouter} from 'react-router-dom';
import Header from './Header';
import Menu from './Menu';
import '../assets/css/thank-you.css';
import { QUESTION } from "../services/Questions";
import {CONFIG, URLS} from '../helpers/Common';
import IdleTimer from 'react-idle-timer'
import Loader from './Loader';

class Thankyou extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
            patientData:'',
            redirect: false,
            surgeon_id: '',
            isLoading : false,
        };
        this.savePatientNarratives  = this.savePatientNarratives.bind(this);
        this.idleTimer = null
        this.onIdle = this._onIdle.bind(this)
        // this.redirectToHome         = this.redirectToHome.bind(this);
        
    }

    componentWillMount()
    {
        const patientData = localStorage.getItem('data');
        if(!patientData)
        {   
            this.props.history.push('/');
        }

        this.setState({
            patientData:JSON.parse(patientData)
        })
    }
    
    _onIdle(e) {
        console.log('user is idle', e)
        console.log('last active', this.idleTimer.getLastActiveTime())
        localStorage.removeItem('data');
        localStorage.removeItem('patientProfile');
        this.setState({redirect: true});
    }

    componentDidMount() {
        //Clear local storage on close
        window.addEventListener("beforeunload", (ev) => {
            ev.preventDefault();
            localStorage.removeItem('data');
            localStorage.removeItem('patientProfile');
            this.setState({redirect: true});
        });
    }


    savePatientNarratives = (isExport)=>
    {

        this.setState({
            isLoading : true,
        })

        let all_complains = JSON.parse(localStorage.getItem("allComplains"));
        let newData = JSON.parse(localStorage.getItem("newData"));

        let data = this.state.patientData;
        data.isExport   = isExport;
        data.surgeon_id=this.state.surgeon_id;
        data.all_complaints=all_complains;
        data.newData=newData;

        QUESTION.savePatientNarratives(data).then(res => {
            localStorage.removeItem('data');
            localStorage.removeItem('patientProfile');
            localStorage.removeItem("allComplains");
            this.setState({redirect: true});
            
        }).catch(err => {
            console.log(err);
            alert("There was an error ");
            this.setState({redirect: true});
        });
       
    }
    render() {
    if (this.state.redirect) {
        return <Redirect push to="/" />;
    }
    return (
        <React.Fragment>
            <IdleTimer
            ref={ref => { this.idleTimer = ref }}
            element={document}
            onIdle={this.onIdle}
            debounce={250}
            timeout={1000 * 60 * CONFIG.IdleTimeOut} />
            <Header title="Narrative Accepted" titleImage="ic-medical-result.png" />
            <Menu />
            <div className="thank-you-bg">
            <section className="thank-you">
                <div className="txt-content">
                    <div className="container">
                        <img src={require("../assets/img/icons/ic-check.png")} alt="" />
                        <h2>Thank you for sharing a detailed history of your symptoms. This information will be shared with the Physician for diagnosis. </h2>
                        <p>If you wish to email yourself a copy of this history, please select the option given below. </p>
                    </div>
                </div>
            </section>

                <div className="sec-btn thank--btn">
                    <div className="loading-spiner" style={{visibility: this.state.isLoading ? 'visible' : 'hidden' }}>
                        <div style={{display: 'flex', justifyContent: 'center',position: 'absolute',left: '50%',top: '50%',transform: 'translate(-50%, -50%)'}}>
                            <Loader/>
                        </div>
                    </div>
                    <Link to="#" onClick={() => this.savePatientNarratives(false)} className="btn-img" style={{visibility: !this.state.isLoading ? 'visible' : 'hidden'}}>
                        <img src={require("../assets/img/icons/ic-close.png")} alt="" />
                        <span>Close</span>
                    </Link>
                    <Link to="#" onClick={() => this.savePatientNarratives(true)} className="btn-img" style={{visibility: !this.state.isLoading ? 'visible' : 'hidden' }}>
                        <img src={require("../assets/img/icons/ic-export.png")} alt="" />
                        <span>Export<br />Narrative</span>
                    </Link>
                </div>
            </div>
        </React.Fragment>
    );
  }
}

export default Thankyou;

